export const URL_LOAN_APPLICATIONS = "/register/loan_application";
export const URL_LOAN_APPLICATIONS_RESCHEDULE =
  "/register/loan_application_reschedule";
export const URL_LOAN_APPLICATIONS_DRAFTS = "/register/loan_application_drafts";
export const URL_LEDGERS = "/register/ledgers";
// export const URL_MERCHANT_SUB_LEDGERS = "/reports/merchant_sub_ledgers";
export const URL_INSTALMENTS = "/register/instalments";
export const URL_PURCHASE_ORDERS = "/register/purchase_order";
export const URL_INVENTORY = "/register/inventory";
export const URL_PRODUCTS = "/register/products";
export const URL_PAYROLL = "/register/payrolls";
export const URL_EXPENSES = "/register/expenses";
export const URL_REQUISITIONS = "/register/requisitions";
export const URL_OTHER_INCOME = "/register/other_income";
export const URL_PAYMENTS_REPORT = "/register/payments_report";
export const URL_LOAN_REPAYMENTS_REPORT = "/register/loan_repayments_report";
export const URL_LOAN_APPLICATIONS_REPORT = "/reports/loan-applications-report";
export const URL_DEBTORS_AGEING_REPORT = "/register/debtors_ageing_report";
export const URL_LEDGER_REPORT = "/register/ledger_report";
export const URL_CHARGE_ASSIGNMENT = "/charge_assignment";
// USERS
export const URL_USERS = "/users";
export const URL_APPLICATION_USERS = "/application_users";
export const URL_REJECTED_APPLICATION_USERS = "/rejected_application_users";
export const URL_AGENTS = "/agents";
export const URL_MERCHANTS = "/merchants";
export const URL_PUBLIC_USERS = "/public_users";
export const URL_STAFF_USERS = "/staff_users";

export const URL_ROLES = "/roles";
export const URL_REPLENISHMENT = "/replenishment";

// DISBURSEMENTS
export const URL_OUTGOING_REQUESTS = "/outgoing_requests";
export const URL_INCOMING_REQUESTS = "/incoming_requests";
export const URL_TRANSACTION_LOGS = "/transaction_logs";
export const URL_CUSTOMER_DETAILS = "/customer_details";
export const URL_ERROR_LOGS = "/error_logs";

// Transaction Processing
export const URL_PARTNER_ITEM_MAPPING = "/partner_item_mapping";
export const URL_REVERSE_TRANSACTIONS = "/reverse_transactions";
export const URL_MARK_TRANSACTION = "/mark_transaction";
export const URL_MONITORED_ACCOUNTS = "/monitored_accounts";
export const URL_ACCOUNT_ALERTS = "/account_alerts";
export const URL_CREDIT_HOLDING_TYPES = "/credit_holding_types";
export const URL_DEBIT_HOLDINGS_TYPES = "/debit_holdings_types";
export const URL_LIQUIDATION_BANK_CODES = "/liquidation_bank_codes";
export const URL_DEBIT_HOLDINGS = "/debit_holdings";
export const URL_CREDIT_HOLDINGS = "/credit_holdings";
export const URL_BANK_ACCOUNTS = "/bank_accounts";
export const URL_LIQUIDATIONS = "/liquidations";

// CONFIGURABLES
export const URL_CONFIGURABLES = "/configurables";
export const URL_INTEREST_CONFIGURABLES = "/interest_configurables";
export const URL_PERIOD_CONFIGURABLES = "/period_configurables";
export const URL_FEES_CONFIGURABLES = "/fees_schedule_configurables";
export const URL_SUPPLIER_CONFIGURABLES = "/supplier_configurables";
export const URL_CHARTS_CONFIGURABLES = "/charts_of_accounts_configurables";
export const URL_ALLOWANCE_TYPES_CONFIGURABLES =
  "/allowance_types_configurables";
export const URL_PAYMENT_MODES_CONFIGURABLES = "/payment_modes_configurables";
export const URL_MERCHANT_INDUSTRIES_CONFIGURABLES =
  "/merchant_industries_configurables";
export const URL_MERCHANT_BUSINESS_CONFIGURABLES =
  "/merchant_business_configurables";
export const URL_USER_TRANSACTIONS = "/user_transactions";

// MASTER DATA
export const URL_MASTER_DATA = "/master_data";
export const URL_DISTRICTS = "/districts";
export const URL_COUNTIES = "/counties";
export const URL_SUB_COUNTIES = "/sub_counties";
export const URL_PARISHES = "/parishes";
export const URL_VILLAGES = "/villages";

// AUDIT ACTIVITY
export const URL_AUDIT_ACTIVITY = "/audit_activity";
export const URL_SECURITY_ACTIVITY = "/security_activity";
export const URL_BUSINESS_AUDIT_LOGS = "/business_audit_logs";

// OFFICES
export const URL_DEPARTMENTS = "/departments";

// ORGANISATION
export const URL_ORGANISATIONS = "/organisations";

// PASSWORD RESET
export const URL_PASSWORD_RESET = "/password_reset";
export const URL_RESET_PIN = "/reset_pin";
export const URL_SETTINGS = "/settings";

// LOGIN
export const URL_LOGIN = "/login";
export const URL_REGISTER = "/register";

//APPLY
export const URL_APPLY_AS_MERCHANT = "/application/merchant";
export const URL_APPLY_AS_AGENT = "/application/agent";

// SERVICES && FEES
export const URL_PAYMENT_ITEMS = "/payment_items";
export const URL_PARTNERS = "/partners";
export const URL_MERCHANT_FEES = "/merchant_fees";
export const URL_YOYA_FEES = "/merchant_fees";
export const URL_YOYA_CHARGES = "/yoya_charges";
export const URL_PARTNER_CHARGES = "/partner_charges";
export const URL_PAYMENT_SERVICES = "/payment_services";
export const URL_MERCHANT_SERVICE_ACCESS = "/merchant_service_access";

//SYSTEM REPORTS
export const URL_UTILITY_LOGS = "/utility_logs";

//WALLET TRANSFERS
export const URL_WALLET_TRANSFERS = "/register/wallet_transfers";

//FINANCE & TREASURY
export const URL_FLOAT_INTEREST_CONFIGS = "/float_interest_configs";
export const URL_FLOAT_INTEREST_STATEMENTS = "/float_interest_statements";
export const URL_SETTLEMENT_BATCHES = "/settlement_batches";
export const URL_SETTLEMENT_RULES = "/settlement_rules";
export const URL_SETTLEMENT_BENEFICIARIES = "/settlement_beneficiaries";
export const URL_SETTLEMENT_APPROVALS = "/settlement_approvals";

export const URL_UTILITY_PAYMENTS = "/register/utility_payments";
export const URL_UTILITY_TRANSACTIONS = "/utility_transactions";

//PAYMENT TYPES
export const URL_PAYMENT_TYPES = "/payment_types";
export const URL_COMPOSITE_ITEMS = "/composite_items";

//WORKFLOWS
export const URL_WORKFLOWS = "/workflows";
export const URL_SCRUTINY_WORKFLOW = "/scrutiny_workflows";

//RECONCILIATIONS
export const URL_RECONCILIATIONS_REPORTS = "/reconciliations_reports";

//PAYMENT USERS MATRIX
export const URL_INTERNAL_MERCHANT_ACCESS = "/internal_merchant_access";
export const URL_MERCHANT_IP_WHITELIST = "/merchant_ip_whitelist";

//MERCHANT USERS
export const URL_MERCHANT_USERS = "/merchant_users";
export const URL_TRANSACTION_MONITORING = "/transaction_monitoring";
export const URL_RECONCILIATION_STATEMENTS = "/reconciliation_statements";

export const URL_SYSTEM_WALLETS = "/system_wallets";

//QR CODE TRANSACTIONS
export const URL_QRCODE_TRANSACTIONS = "/qrcode_transactions";

//MERCHANT CODE TRANSACTIONS
export const URL_LIQUIDATION_CONFIGURABLES = "/liquidation_configurations";
// QR CODE PAYMENTS
export const URL_DYNAMIC_QR_CODE = "/dynamic_qr_code";
export const URL_QR_CODE_HISTORY = "/qr_code_history";
export const URL_QR_CODE_PAYMENT = "/qr_code_payments";
export const URL_QR_CODE_RECEIPT_CONFIGURATIONS =
  "/qr_code_receipt_configurations";
export const URL_QR_CODE_MERCHANT_SERVICES = "/qr_code_merchant_services";

//MERCHANT CODES
export const URL_MERCHANT_CODES = "/merchant_codes";
// FRAUD DETECTION
export const URL_FRAUD_DASHBOARD = "/fraud_dashboard";
export const URL_FRAUD_RULES = "/fraud_rules";
export const URL_FRAUD_EVENTS = "/fraud_events";
export const URL_FRAUD_RULES_HISTORY = "/fraud_rules_history";
export const URL_FRAUD_AUDIT_LOGS = "/fraud_audit_logs";

export const URL_FRAUD_WEIGHTSCORE = "/fraud_weight_score";
export const URL_FRAUD_ALERTS = "/fraud_alerts";
export const URL_FRAUD_CASES = "/fraud_cases";
export const URL_FRAUD_TEMPLATES = "/fraud_templates";
export const URL_FRAUD_CONFIGURATIONS = "/fraud_configurations";

//MERCHANT PAYMENT
export const URL_MERCHANT_PAYMENTS = "/merchant_payments";

//IFRAME PAYMENTS
export const URL_IFRAME_PAYMENTS = "/iframe_payments";

//USSD SERVICES
export const URL_SET_USSD_MERCHANT = "/set_ussd_merchant";
export const URL_USSD_INPUT_LOGS = "/ussd_input_logs";
export const URL_USSD_CUSTOMER_TRANSACTIONS = "/ussd_customer_transactions";
export const URL_USSD_INCOMING_LOGS = "/ussd_incoming_logs";
export const URL_USSD_OUTGOING_LOGS = "/ussd_outgoing_logs";
export const URL_USSD_CONFIGURABLES = "/ussd_configurables";
export const URL_USSD_SAFEGUARDS = "/ussd_safeguards";

//SUMMARY REPORTS
export const URL_MONTHLY_SUMMARY = "/reports/transaction-summary-summary";
export const URL_PAYMENT_ITEM_MONTHLY_REPORT = "/reports/payment-item-report";
export const URL_MERCHANT_MONTHLY_REPORT = "/reports/merchant-summary-report";
export const URL_PARTNER_COMMISSION_SUMMARY =
  "/reports/partner-commission-summary";
export const URL_AGENT_COMMISSION_SUMMARY = "/agent-commission-summary";
export const URL_YOYA_COMMISSION_SUMMARY = "/yoya-commission-summary";

//REPORTS
export const URL_TRIAL_BALANCE = "/trial_balance";
export const URL_TRANSACTION_SUMMARY = "/reports/transaction_summary";
export const URL_MERCHANT_SUMMARY = "/reports/merchant_summary";
export const URL_PAYMENT_ITEM_SUMMARY = "/reports/payment_item_summary";
export const URL_TRANSACTION_CHANNEL_SEPARATION =
  "reports/transaction_channel_separation";
export const URL_PAYMENT_ITEM_CHANNEL_REPORT =
  "reports/payment_item_channel_report";
export const URL_INCIDENT_TICKET_CATEGORY = "/incident_ticket_category";
export const URL_INCIDENT_TICKET_CATEGORY_REPORT =
  "reports/incident-ticket-category/";
export const URL_INCIDENT_TICKET_SEVERITY = "/incident_ticket_severity";
export const URL_INCIDENT_TICKET_SEVERITY_REPORT =
  "reports/incident-ticket-severity/";

//SUPPORT
export const URL_INCIDENT_TICKETING = "/incident_ticketing";
export const URL_TICKET_CATEGORIZATION = "/ticket_categorization";
export const URL_RAISED_TICKETS = "/raised_tickets";
export const URL_ASSIGNED_TICKETS = "/assigned_tickets";
export const URL_TICKET_RESOLUTION = "/ticket_resolution";
export const URL_TICKET_CLOSURE = "/ticket_closure";
export const URL_TICKET_ESCALATION = "/ticket_escalation";

//CONTACT US
export const URL_CONTACT_US = "/enquiries";
